export enum Variant {
    Success = 'success',
    Warning = 'warning',
    Information = 'information',
    Neutral = 'neutral',
}

export interface VariantColor {
    color: string
    background: string
}
